import uniqueId from "lodash.uniqueid";

export default {
  state: {
    toasts: []
  },
  mutations: {
    addToast(state, toast) {
      state.toasts.push(toast)
    },
    clearToast(state, id) {
      const index = state.toasts.findIndex((toast) => toast.id === id)
      state.toasts.splice(index, 1)
    }
  },
  actions: {
    createNotification({commit}, payload) {
      commit('addToast', {...payload, id: uniqueId()})
    },
    deleteNotification({commit}, payload) {
      commit('clearToast', payload)
    }
  },
  getters: {
    getToasts: state => state.toasts
  }
}